import { useSelector, useDispatch } from 'react-redux'
import { useRouter } from 'next/router'
import { apiGet, getToken, setToken } from 'tennders-stracture/libs/api'
import { dispatchLogout, dispatchUser } from 'tennders-auth/stores/action'
import { StateType } from 'tennders-common/types/StateType'
import useLoadsStore from 'tennders-market/load/stores/useLoadsStore'
import useTrucksStore from 'tennders-market/truck/stores/useTrucksStore'
import useTransactionsStore from 'tennders-market/bin/stores/useTransactionsStore'

const useSession = () => {
  const [resetLoads] = useLoadsStore((state: Record<string, any>) => [state.resetLoads])
  const [resetTrucks] = useTrucksStore((state: Record<string, any>) => [state.resetTrucks])
  const [resetTransactions] = useTransactionsStore((state: Record<string, any>) => [state.resetTransactions])
  const router = useRouter()
  const dispatch = useDispatch()
  const user = useSelector((state: StateType) => state.auth.user)
  const isLogout = useSelector((state: StateType) => state.auth.isLogout)
  const setUser = (user) => dispatch(dispatchUser(user))
  const setLogout = (isLogout) => dispatch(dispatchLogout(isLogout))

  const logout = () => {
    setToken('')
    setUser(false)
    setLogout(true)
    router.replace('/auth/login')
    resetLoads()
    resetTrucks()
    resetTransactions()
  }

  const fetchUser = async () => {
    if (getToken()) {
      const response = await apiGet('/account/info')
      if (response) {
        setUser(response)
        if (response?.redirectUrl) {
          router.replace(response.redirectUrl)
        }
      } else {
        logout()
      }
      return response
    }
  }

  const isShipper = () => user?.roles?.includes('shipper')
  const isCarrier = () => user?.roles?.includes('carriers')
  const isBroker = () => (
    user?.roles?.includes('broker')
    || user?.roles?.includes('broker-qc')
    || user?.roles?.includes('admin') || user?.roles?.includes('broker-manager')
  )

  const isBrokerManager = () => user?.roles?.includes('broker-manager')
  const isQC = () => user?.roles?.includes('broker-qc')
  const isAdmin = () => user?.roles?.includes('admin')
  const isNetworkUser = () => user?.isNetworkUser
  const isMyCompany = (company) => user?.company?.id === company?.id
  const isMe = (checkUser) => checkUser && user && user.id === checkUser.id

  const isShipperUser = isShipper()
  const isCarrierUser = isCarrier()
  const isBrokerUser = isBroker()

  return {
    isBroker,
    isBrokerManager,
    isShipper,
    isCarrier,
    isShipperUser,
    isCarrierUser,
    isBrokerUser,
    isLogout,
    isQC,
    user,
    isMe,
    isMyCompany,
    setUser,
    logout,
    setLogout,
    fetchUser,
    isAdmin,
    isNetworkUser
  }
}

export default useSession
